<template>
  <Tables
    ref="tableGrid"
    :columns="[
      'Ação',
      'Status Proc.',
      'Ultima Att.',
      'Criado Por',
      'Criado Em'
    ]"
    :showTipFooter="false"
    v-on:Load="onLoadAcoes"
  >
    <tr v-for="obj in this.objList" v-bind:key="obj.id">
      <TableColumn
        :IsText="true"
        :status="obj.inative ? 0 : 1"
        :value="obj.acaoListaInteligente"
      />
      <td class="text-center">
        <span
          v-if="obj.statusProcessamento === 'Sucesso'"
          class="badge badge-success text-toupper"
        >
          {{ obj.statusProcessamento }}
        </span>
        <span
          v-else-if="obj.statusProcessamento === 'Aguardando'"
          class="badge badge-primary text-toupper"
        >
          {{ obj.statusProcessamento }}
        </span>
        <span
          v-else-if="obj.statusProcessamento === 'Processando'"
          class="badge badge-info text-toupper"
        >
          {{ obj.statusProcessamento }}
        </span>
        <span v-else class="badge badge-danger text-toupper">
          {{ obj.statusProcessamento }}
        </span>
      </td>
      <TableColumn
        :IsDatetime="true"
        :status="obj.inative ? 0 : 1"
        :value="obj.updatedStatusAt"
      />
      <TableColumn
        :IsText="true"
        :status="obj.inative ? 0 : 1"
        :value="obj.createdBy.nomePessoa"
      />
      <TableColumn
        :IsDatetime="true"
        :status="obj.inative ? 0 : 1"
        :value="obj.createdAt"
      />
    </tr>
  </Tables>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import ListaInteligenteRepository from '@/shared/http/repositories/configurations/listainteligente.js'

export default {
  name: 'AcaoListaInteligenteGrid',
  mixins: [ActionsForm],
  data () {
    return {
      listaInteligenteId: null
    }
  },
  mounted () {
    setInterval(() => {
      try {
        if (this.$refs.tableGrid && this.listaInteligenteId) {
          ListaInteligenteRepository.GetAllAcaoByListaInteligetePaging(this.listaInteligenteId, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
            .then(this.onResultGrid)
            .catch(e => console.error(e))
        }
      } catch (e) {
        console.error(e)
      }
    }, 1000)
  },
  methods: {
    onLoadAcoes (listaInteligenteId) {
      if (listaInteligenteId) {
        loading.push()
        this.listaInteligenteId = listaInteligenteId
        ListaInteligenteRepository.GetAllAcaoByListaInteligetePaging(listaInteligenteId, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
        loading.pop()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/add/grids/AcaoListaInteligenteGrid.vue